export default __webpack_public_path__ + "static/media/sz.af91e9da.svg";